import Page from './Page';
import Header from './components/header/Header';
import PageForm from './components/PageForm';
import PageTable from './components/PageTable';
export default Page;
export { Header, PageForm, PageTable};